export const JWT_TOKEN = 'JWT_TOKEN'



// WEBPACK FOOTER //
// ./src/constants/Auth.tsx